import { render, staticRenderFns } from "./characteristic.vue?vue&type=template&id=15b464e3&scoped=true"
import script from "./characteristic.vue?vue&type=script&lang=js"
export * from "./characteristic.vue?vue&type=script&lang=js"
import style0 from "./characteristic.vue?vue&type=style&index=0&id=15b464e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b464e3",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/product/interview/characteristic.vue
// module id = null
// module chunks = 